import { useState } from "react";
import { Link } from "react-router-dom";
import { FaGraduationCap, FaInfoCircle, FaSignInAlt, FaBars, FaTimes } from "react-icons/fa";
import "./TopBar.css";

function TopBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = isMenuOpen ? "auto" : "hidden";
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  return (
    <>
      <nav className="topbar">
        <Link to="/" className="logo" onClick={closeMenu}>
          <FaGraduationCap className="logo-icon" />
          <span className="logo-text">TeachMeGo</span>
        </Link>

        {/* Desktop Navigation */}
        <div className="topbar-links">
          <Link to="/about" className="topbar-link">
            <FaInfoCircle className="topbar-link-icon" />
            <span>About TeachMeGo</span>
          </Link>
          <Link to="/auth" className="topbar-btn">
            <FaSignInAlt className="topbar-btn-icon" />
            <span>Sign Up / Login</span>
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button 
          className={`mobile-menu-toggle ${isMenuOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        {/* Mobile Menu Overlay */}
        <div className={`mobile-menu ${isMenuOpen ? "active" : ""}`}>
          <Link to="/about" className="mobile-menu-link" onClick={closeMenu}>
            <FaInfoCircle />
            <span>About TeachMeGo</span>
          </Link>
          <Link to="/auth" className="mobile-menu-link mobile-menu-btn" onClick={closeMenu}>
            <FaSignInAlt />
            <span>Sign Up / Login</span>
          </Link>
        </div>
      </nav>
    </>
  );
}

export default TopBar;
